import { Entity } from '@backstage/catalog-model';
import { WitboostEntity, WitboostSystem } from './model';
import { SkeletonParameters } from '@agilelab/plugin-wb-catalog-extension-common';

export interface MicroserviceConfig {
  microserviceId: string;
  baseUrl: string;
  retrievalPath?: string;
  validationPath?: string;
  retrievalMethod?: string;
  validationMethod?: string;
  apiKey?: string;
}

/**
 * Type used to combine Data Product/Components info and their environments
 */
export type DataProductAndEnvironmentConfiguration = {
  dataProduct: WitboostSystem;
  configuration: any;
  components: { component: WitboostEntity; configuration: any }[];
};

export type Release = {
  date: string;
  link: string;
  environment: string;
};

export enum RELATION_DEPENDENCY {
  READS_FROM = 'wb-readsFrom',
  IS_READ_BY = 'wb-isReadBy',
  LOGICALLY_READS_FROM = 'wb-logicallyReadsFrom',
  IS_LOGICALLY_READ_BY = 'wb-isLogicallyReadBy',
}

export enum RELATION_SYSTEM_OWNERSHIP {
  SYSTEM_OWNER_OF = 'wb-systemOwnerOf',
  SYSTEM_OWNED_BY = 'wb-systemOwnedBy',
}

export enum RELATION_SYSTEM_DEVELOPER {
  DEVELOPER_OF = 'wb-developerOf',
  DEVELOPED_BY = 'wb-developedBy',
}

export const RELATION_HAS_MAIN_TEMPLATE = 'wb-hasMainTemplate';
export const RELATION_MAIN_TEMPLATE_OF = 'wb-mainTemplateOf';
export const RELATION_EDITABLE_BY = 'wb-editableBy';
export const RELATION_CAN_EDIT = 'wb-canEdit';

export type CatalogEntityRelation = {
  type: string;
  source: Entity;
  target: Entity;
};

export type RepositoryFile = {
  repoUrl: string;
  branch: string;
  /**
   * e.g. dir1/dir2/file-name.ext
   */
  filePath: string;
  /**
   * File content
   */
  content: string;
  /**
   * Commit hash (commit ID) associated with the version of the file's content
   */
  commit: string;
};

export type SkeletonInfo = {
  catalogInfoData: { rawData: Buffer; url: string; branch: string };
  parametersData: {
    parameters: SkeletonParameters;
    url: string;
    branch: string;
  };
};

export type CatalogInfoFile = RepositoryFile & {
  parsedCatalogInfo: any;
  isSkeleton: boolean;
} & { [key: string]: any };

export type EntityAndBranch = {
  entityRef: string;
  branch: string;
  commitUid?: string;
};

export type ValidationErrorDescriptor = string | undefined;
